const API = 'https://database-linkr.herokuapp.com'

export {API}
